import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { AuthInterceptor } from './core/authentication/auth.interceptor';
import { HttpErrorInterceptor } from './core/interceptors/http-error.interceptor';
import * as Sentry from "@sentry/capacitor";
import * as SentryAngular from "@sentry/angular";
import packageInfo from '../../package.json';
import { environment } from 'src/environments/environment';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';

export function playerFactory() {
  return player;
}

Sentry.init(
  {
    dsn: "",
    release: `deliverymaster@${packageInfo.version}`,
    dist: "1",
    maxValueLength: 1024,
    normalizeDepth: 5,
    integrations: [
      SentryAngular.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    enableCaptureFailedRequests: true,
    tracesSampleRate: 0.01,
    tracePropagationTargets: ["localhost", environment.apiBaseUrl],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  },
  SentryAngular.init
);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: SentryAngular.createErrorHandler(),
    },
    {
      provide: SentryAngular.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [SentryAngular.TraceService],
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
